export default __webpack_public_path__ + "media/images/mailer-new/welcome/feature_audience-26de47c753380be65134d3fd9c43cb0d.png";